// extracted by mini-css-extract-plugin
export default {"menuContainer":"styles_menuContainer__OfPx9","menuItem":"styles_menuItem__F9CjA","gradienetText":"styles_gradienetText__00LBW","menuItemActive":"styles_menuItemActive__Jgooe"};